import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=e89eb43e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e89eb43e')) {
      api.createRecord('e89eb43e', component.options)
    } else {
      api.reload('e89eb43e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=e89eb43e&", function () {
      api.rerender('e89eb43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZIOBywhHO3an/JS/videoIframe.vue"
export default component.exports